const CHF_FORMATTER = new Intl.NumberFormat('fr-CH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatChf(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? CHF_FORMATTER.format(amount) : '—';
}
